import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

const TOKEN_KEY = "pf_token";
export const setAuthToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

client.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const login = async (username, password) =>
  (await client.post("/auth/login", { username, password })).data;
export const fetchMe = async () => (await client.get("/auth/me")).data;

export const listUsers = async () => (await client.get("/auth/users")).data;
export const createUser = async (body) => (await client.post("/auth/users", body)).data;
export const resetUserPassword = async (username, password) =>
  (await client.post(`/auth/users/${encodeURIComponent(username)}/password`, { password })).data;
export const deleteUser = async (username) =>
  (await client.delete(`/auth/users/${encodeURIComponent(username)}`)).data;
export const changeMyPassword = async (current_password, new_password) =>
  (await client.post("/auth/change-password", { current_password, new_password })).data;
export const getAllBuyers = async () => (await client.get("/auth/buyers")).data;

const qs = (params) => {
  const clean = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== "all") clean[k] = v;
  });
  return clean;
};

export const uploadReport = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await client.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const getMeta = async () => (await client.get("/meta")).data;
export const getFilters = async (snapshot_id) =>
  (await client.get("/filters", { params: qs({ snapshot_id }) })).data;
export const getAnalytics = async (filters) =>
  (await client.get("/analytics", { params: qs(filters) })).data;
export const getOrders = async (params) =>
  (await client.get("/orders", { params: qs(params) })).data;
export const getRef2 = async (ref2, snapshot_id) =>
  (await client.get(`/ref2/${encodeURIComponent(ref2)}`, { params: qs({ snapshot_id }) })).data;
export const getHistory = async (buyer) =>
  (await client.get("/history", { params: qs({ buyer }) })).data;
export const getAlerts = async (params) =>
  (await client.get("/alerts", { params: qs(params) })).data;
export const getCompare = async (base_id, target_id) =>
  (await client.get("/compare", { params: qs({ base_id, target_id }) })).data;
export const findRef = async (q, snapshot_id, field) =>
  (await client.get("/find", { params: qs({ q, snapshot_id, field }) })).data;

export const findBulk = async (queries, field) =>
  (await client.post("/find/bulk", { queries, field })).data;

const triggerDownload = (res, fallback) => {
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const name = m ? m[1] : fallback;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const exportFind = async (queries, field) => {
  const res = await client.post("/find/export", { queries, field }, { responseType: "blob" });
  triggerDownload(res, "procureflow_lookup.xlsx");
};

export const exportOrders = async (params) => {
  const res = await client.get("/orders/export", { params: qs(params), responseType: "blob" });
  triggerDownload(res, "procureflow_order_lines.xlsx");
};

export const exportAlerts = async (params) => {
  const res = await client.get("/alerts/export", { params: qs(params), responseType: "blob" });
  triggerDownload(res, "procureflow_stuck_alerts.xlsx");
};

export const getDrivers = async () => (await client.get("/drivers")).data;
export const addDrivers = async (codes) => (await client.post("/drivers", { codes })).data;
export const deleteDriver = async (code) => (await client.delete(`/drivers/${encodeURIComponent(code)}`)).data;
export const clearDrivers = async () => (await client.delete("/drivers")).data;

export const exportDashboard = async () => {
  const res = await client.get("/dashboard/export", { responseType: "blob" });
  triggerDownload(res, "procureflow_dashboard.xlsx");
};

export const getLineLeaderboard = async (base_id, target_id) =>
  (await client.get("/line-leaderboard", { params: qs({ base_id, target_id }) })).data;
